var _path, _rect, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0919 0C1.04595 0 0 1.01653 0 2.91191L7.13831e-06 18.9274C7.13831e-06 19.7594 0.35892 20.7994 2.0919 20.7994H14.6433C16.3763 20.7994 16.7352 20.2794 16.7352 18.9274V7.27977C16.7352 2.85721 14.5031 0 10.4595 0H2.0919ZM2.0919 1.03997H10.4595V6.23981H15.6892V18.9274C15.6892 19.5592 15.2209 19.7594 14.6433 19.7594H2.0919C1.51424 19.7594 1.04596 19.5592 1.04596 18.9274V2.91191C1.04595 1.55995 1.51424 1.03997 2.0919 1.03997ZM11.5054 1.03997C13.1908 1.41414 15.1663 2.59992 15.6892 5.19984H11.5054V1.03997Z",
    fill: "#0466C9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.78027,
    y: 10.5361,
    width: 8.78022,
    height: 10.5363,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5605,
    y1: 19.5669,
    x2: 11.4144,
    y2: 19.5669,
    stroke: "#0466C9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.471 18.4385L16.6826 16.4188L15.9565 15.7354L14.9948 16.6136L15.0363 10.5363H13.9601V16.5905L13.0297 15.7149L12.2925 16.3881L14.471 18.4385Z",
    fill: "#0466C9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fileDownload.991dcbf39062379c290227d1dee9523c.svg";